import { Box, Heading, Body, Container } from '@hover/blueprint';
import { StyleProps } from '@chakra-ui/react';
import React from 'react';
import InvestorsMobile from './InvestorsMobile';
import InvestorsDesktop from './InvestorsDesktop';

const wrapperStyles: StyleProps = {
  width: '100%',
  flexDir: { base: 'column', desktop: 'row' },
  justifyContent: { base: 'flex-start', desktop: 'space-between' },
  alignItems: { base: 'center', desktop: 'flex-start' },
  pt: { base: 0, desktop: 500 },
  pb: { base: 600, desktop: 0 },
  px: { base: 500, desktop: 900 },
  mt: { tablet: '80px', desktop: 900 },
  mb: 800,
  borderRadius: '4px',
  bg: 'neutral.0',
};

const headingWrapperStyles: StyleProps = {
  mt: 700,
  maxW: { base: '100%', tablet: 'xl', desktop: 'sm' },
  flexDir: 'column',
  alignItems: { base: 'center', desktop: 'flex-start' },
  pl: { base: 0, desktop: 700 },
  pr: 0,
  mx: 0,
};

const Investors: React.FC = () => (
  <Box shadow="distance300" {...wrapperStyles}>
    <Container centerContent {...headingWrapperStyles}>
      <Heading
        as="h3"
        fontWeight={{ base: 600, desktop: 600 }}
        size={{ base: 500, tablet: 600, desktop: 700 }}
        marginBottom={{ base: 500, desktop: 400 }}
      >
        Investors
      </Heading>
      <Body
        fontWeight={{ base: 400, desktop: 400 }}
        size={500}
        textAlign={{ base: 'center', desktop: 'left' }}
        mb={{ base: 500 }}
      >
        We are proud to work with top investors across technology, insurance,
        and home improvement, including some that are also our customers.
      </Body>
    </Container>
    <InvestorsMobile />
    <InvestorsDesktop />
  </Box>
);

export default Investors;
